export default {
    en: {
        id: 'diagram4b2-7',
        blocks: [
            {
                index: '1',
                task: 'S = 83% of MI graduates cheated',
                title: "S = "
            },
            {
                index: '2',
                task: 'C = 17% didn’t',
                title: "C = "
            },
            {
                index: '3',
                task: 'Q = Why not',
                title: "Q = "
            }
        ],
        answers: [
            {
                index: '3',
                title: 'Why not?'
            },
            {
                index: '2',
                title: 'Y doesn’t'
            },
            {
                index: '1',
                title: 'X happens'
            },
        ],
        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
        correctAnswers: 3,
        note: `This one was included (a) to amuse you and (b) because the ease with which you are able to pick out the points should give you confidence that you are indeed learning how to see the structure lurking in an introduction! But it also illustrates the clever technique of bringing up the opposite of the question people would expect you to ask. The futility of having a Why? question at the top still applies, however.`
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b2/spottingSCQ/i18n/exercise7.js